import { render, staticRenderFns } from "./PaxSimulationList.vue?vue&type=template&id=5aaa4f08&"
import script from "./PaxSimulationList.vue?vue&type=script&lang=js&"
export * from "./PaxSimulationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports